import VRMessage from "./VRMessage";
import {PositionOffsetEnum, SceneFollowPositionEnum, DefaultScenePosition} from "../../VRMessage/VRMessageLiterals";

class VRInformation extends VRMessage {

    constructor(properties) {
        super(properties);
        this.camera = properties.Camera;
        this.position = {
            xPosition: DefaultScenePosition.x,
            yPosition: DefaultScenePosition.y,
            zPosition: DefaultScenePosition.z
        };
    }

    updateScalingAndPosition() {
        let updatedScale;
        if (this.isCameraFix && this.camera) {
            if (isVRConnected())  {
                this.canvasHeight *= 0.95;
                this.canvasWidth *= 0.95;
            }

            const cameraFixOffsets = offsetPercentageToPixel(this.camera, this.canvasHeight, this.canvasWidth);
            let {position} = mapScreenDimensionTo3D(cameraFixOffsets, {
                    height: this.canvasHeight,
                    width: this.canvasWidth
                },
                4
            );

            let scale = this.get3DScaling(cameraFixOffsets, this.canvasWidth, this.canvasHeight);
            scale.z = 1;
            this.position.xPosition = position.x;
            this.position.yPosition = position.y;
            this.position.zPosition = position.z;
            updatedScale = scale;
        } else if (this.configData.Scene?.position && this.isSceneFollow) {
            this.position = {
                xPosition: DefaultScenePosition.x,
                yPosition: DefaultScenePosition.y,
                zPosition: DefaultScenePosition.z
            };
        } else if (this.configData.Scene?.position) {
                this.position = {
                    xPosition: this.configData.Scene?.position[0],
                    yPosition: this.configData.Scene?.position[1],
                    zPosition: this.configData.Scene?.position[2]
                };
        }

        this.updateScaling(updatedScale);
        this.updatePosition();
    }

    get3DScaling(cameraFixOffsets1, width, height, depth = 4) {
        const cameraFixOffsets2 = this.createOffsetPoint(cameraFixOffsets1, width, height);

        const point1Config = mapScreenDimensionTo3D(cameraFixOffsets1, {
                height: height,
                width: width
            },
            depth
        );

        const point2Config = mapScreenDimensionTo3D(cameraFixOffsets2, {
                height: height,
                width: width
            },
            depth
        );

        return this.manhattanDistance(point1Config.position, point2Config.position);
    }

    createOffsetPoint(originalOffsets, width, height) {
        const offsetPoint = {};

        if (originalOffsets.left !== undefined) {
            offsetPoint.left = originalOffsets.left + width;
        } else if (originalOffsets.right !== undefined) {
            offsetPoint.right = originalOffsets.right + width;
        }

        if (originalOffsets.top !== undefined) {
            offsetPoint.top = originalOffsets.top + height;
        } else if (originalOffsets.bottom !== undefined) {
            offsetPoint.bottom = originalOffsets.bottom + height;
        }

        return offsetPoint;
    }

    manhattanDistance(point1, point2) {
        const distX = Math.abs(point1.x - point2.x);
        const distY = Math.abs(point1.y - point2.y);

        return {
            x: distX,
            y: distY
        }
    }

    getYPosition() {
        if (this.isCameraFix && this.camera) {
            return this.position.yPosition;
        }

        let offset = 0;
        if (this.isSceneFollow) {
            const offsets = {
                [SceneFollowPositionEnum.TOP]: PositionOffsetEnum.TOP,
                [SceneFollowPositionEnum.MIDDLE]: PositionOffsetEnum.MIDDLE,
                [SceneFollowPositionEnum.BOTTOM]: PositionOffsetEnum.BOTTOM,
                [SceneFollowPositionEnum.DEFAULT]: PositionOffsetEnum.DEFAULT,
            };
            offset = offsets[this.sceneFollowPosition] || 0;
        }

        return (this.position.yPosition + offset) * getFovScaleFactor();
    }

    updateScaling(scale) {
        if (this.isCameraFix && this.camera) {
            this.message.object.scale.copy(scale);
        } else {
            super.updateScaling();
        }
    }

    adjustFovChange() {
        if (this.isCameraFix && this.camera) {
            this.updateScalingAndPosition();
        } else if (this.isCameraFix) {
            super.adjustFovChange();
        }
    }

    updateVRMessageParent() {
        this.parent.remove(this.message.object);
        this.setVRMessageParent((isVRConnected() && !isMobileARModeEnabled()) ? this.configData.VRMode : this.configData.NonVRMode);
        this.parent.add(this.message.object);
    }
}

export default VRInformation;